import React from 'react'
import { Link } from 'react-router-dom'

// Import category images
import TururiPietonaleImg from '../assets/tururipietonale.jpg'
import TururiRegionaleImg from '../assets/ExperienteAutenticeLocale.jpg'
import ExperienteInteractiveImg from '../assets/TreasureHunt.jpg'

function Trips() {
  // Define the 3 category widgets with associated images
  const categories = [
    { label: "Tururi pietonale", slug: "tururi-pietonale", image: TururiPietonaleImg },
    { label: "Tururi regionale", slug: "tururi-regionale", image: TururiRegionaleImg },
    { label: "Experiente interactive", slug: "experiente-interactive", image: ExperienteInteractiveImg },
  ];

  return (
    <div style={styles.pageContainer}>
      <h1 style={styles.heading}>TURURI SI EXPERIENTE</h1>
      <p style={styles.paragraph}>
        Descopera varietatea noastra de tururi si experiente unice.
      </p>
      
      {/* New Descriptive Text Section */}
      <div style={styles.descriptionSection}>
        <p style={styles.descriptionText}>
          <strong>Pasiunea ta pentru descoperire, expertiza noastră</strong>
        </p>
        <p style={styles.descriptionText}>
          Plimbă-te pe străzi încărcate de istorie, descifrează simbolurile ascunse ale arhitecturii locale sau află poveștile neștiute ale orașelor mici din România. Îți arătăm orașele așa cum nu le-ai mai văzut – prin ochii unui ghid pasionat, care îți conectează curiozitatea cu detalii fascinante din artă, gastronomie, istorie sau cultură urbană.
        </p>
        <p style={styles.descriptionText}>
          Fie că explorezi alături de noi pe jos, într-un tur interactiv, fie că participi la o vânătoare de comori sau la o activare de grup, experiențele noastre sunt mai mult decât simple vizite – sunt momente de descoperire autentică și conexiune reală cu locurile și oamenii.
        </p>
        <p style={styles.descriptionText}>
          🔎 Experiențe personalizate pentru călători curioși <br />
          👣 Tururi pietonale, virtuale și activități interactive <br />
          🤝 Oportunități pentru grupuri corporate și evenimente speciale
        </p>
        <p style={{ ...styles.descriptionText, marginBottom: '2rem' }}>
          Ești pregătit să explorezi altfel?
        </p>
      </div>

      {/* Category Widgets Section */}
      <div style={styles.categoriesContainer}>
        {categories.map((cat, index) => (
          <Link
            key={index}
            to={`/trips/${cat.slug}`}
            style={styles.categoryLink}
            onClick={() => window.scrollTo(0, 0)}  // Scroll to top on click
          >
            <div style={styles.categoryCard}>
              <img
                src={cat.image}
                alt={cat.label}
                style={styles.categoryImage}
              />
              <h2 style={styles.categoryTitle}>{cat.label}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  )
}

const styles = {
  pageContainer: {
    backgroundColor: '#F4F9F9',
    padding: '2rem',
    minHeight: '70vh',
    width: '100%',
  },
  heading: {
    fontFamily: 'Georgia, serif',
    fontSize: '3rem', // Larger title
    color: '#C39A79',
    marginBottom: '1rem',
    textAlign: 'center',
  },
  paragraph: {
    fontSize: '1.2rem',
    lineHeight: '1.6',
    color: '#2C3E50',
    marginBottom: '2rem',
    textAlign: 'center',
  },
  descriptionSection: {
    width: '100%',
    margin: '0 auto',
    marginBottom: '2rem', // Additional spacing below
    textAlign: 'center',
    color: '#2C3E50',
    fontFamily: 'Georgia, serif',
  },
  descriptionText: {
    fontSize: '1.1rem',
    lineHeight: '1.7',
    margin: '0.5rem auto',
    padding: '0 1rem', // Slight side padding for readability
    maxWidth: '1000px', // If you still want to limit line length
  },
  categoriesContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '2rem',
    marginBottom: '3rem',
    flexWrap: 'wrap',
  },
  categoryLink: {
    textDecoration: 'none',
    color: '#2C3E50',
    transition: 'color 0.3s ease',
  },
  categoryCard: {
    width: '350px',
    height: '300px',
    backgroundColor: '#FFF',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
  },
  categoryImage: {
    width: '100%',
    height: '70%',
    objectFit: 'cover',
  },
  categoryTitle: {
    fontFamily: 'Georgia, serif',
    fontSize: '1.8rem',
    color: '#2C3E50',
    margin: '1rem 0',
    textAlign: 'center',
  },
}

export default Trips
